import React from 'react';
import ErrorOutlineRounded from '@mui/icons-material/ErrorOutlineRounded';

// New UI only (docs/ui_redesign/18-ux-review.md, R4): a full-screen editor whose data couldn't load says so and offers
// Close, instead of a blank screen with no way out. Close runs the screen's own close handler.
export function loadFailedHint(message) {
	const m = String(message || '');
	if (/status code 404|not found/i.test(m)) return 'It may have been deleted, or moved to another company.';
	if (/status code 403|unauthori[sz]ed/i.test(m)) return 'You may not have access to it.';
	if (/network error|timeout/i.test(m)) return 'Check your connection, then try again.';
	// A message from the server reads as a sentence; a script error ("Cannot read properties of undefined") doesn't.
	const technical = /^request failed|cannot read|undefined|is not a function|unexpected token|json|typeerror/i.test(m);
	return m && !technical ? m : 'Close this screen and try again.';
}

export default function LoadFailed({ what = 'invoice', message, onClose }) {
	return (
		<div className="apw2 apw2-loadfail" role="alertdialog" aria-labelledby="apw2-loadfail-t" aria-describedby="apw2-loadfail-d">
			<div className="apw2-loadfail-card">
				<ErrorOutlineRounded aria-hidden="true" />
				<h1 id="apw2-loadfail-t">Couldn&rsquo;t open this {what}</h1>
				<p id="apw2-loadfail-d">{loadFailedHint(message)}</p>
				<button type="button" className="apw2-btn primary" onClick={onClose} autoFocus>Close</button>
			</div>
		</div>
	);
}
